import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAdditionalInfo, UpdateAdditionalInfo } from "../../../StateManagement/Reducers/AdditionalInfoState";
import { Select, Switch, DatePicker } from "antd";
import dayjs from "dayjs";
import {
  Text,
  Div,
  Button,
  FormGroup,
  FormLabel,
} from "../../StyledComponents";
import {
  Display,
  Inputbox,
  Hrline,
} from "../EditProfile/styles";

const { Option } = Select;

const AdditionalInfo = ({ value, value1 }) => {
  // School Information
  const [schoolName, setSchoolName] = useState("");
  const [grade, setGrade] = useState("");
  const [studentStatus, setStudentStatus] = useState("");

  // Guardian Information
  const [guardianFullName, setGuardianFullName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [guardianRelationship, setGuardianRelationship] = useState("");

  // Custody Information
  const [custodyStatus, setCustodyStatus] = useState("");
  const [legalCustodianFullName, setLegalCustodianFullName] = useState("");
  const [custodianRelationship, setCustodianRelationship] = useState("");
  const [custodyOrderOnFile, setCustodyOrderOnFile] = useState(false);
  const [custodyEffectiveDate, setCustodyEffectiveDate] = useState(null);
  const [custodyNotes, setCustodyNotes] = useState("");

  // Employment Information
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [occupation1, setOccupation1] = useState("");

  // Housing Information
  const [housingStatus, setHousingStatus] = useState("");
  const [livingArrangement, setLivingArrangement] = useState("");
  const [householdSize, setHouseholdSize] = useState("");

  // Social Information
  const [occupation2, setOccupation2] = useState("");
  const [smokingStatus, setSmokingStatus] = useState("");
  const [veteranStatus, setVeteranStatus] = useState("");
  const [disabilityStatus, setDisabilityStatus] = useState("");

  // Client Notes
  const [clientNotes, setClientNotes] = useState("");
  // const localStorage.getItem("PID");



  const dispatch = useDispatch();
  const AdditionalInfoData = useSelector((state) => state.AdditionalInfo.AdditionalInfoData) || {};

  useEffect(() => {
    dispatch(GetAdditionalInfo());
  }, [dispatch]);

  useEffect(() => {
    if (AdditionalInfoData && Object.keys(AdditionalInfoData).length > 0) {
      setSchoolName(AdditionalInfoData.school_name || "");
      setGrade(AdditionalInfoData.grade || "");
      setStudentStatus(AdditionalInfoData.student_status || "");
      setGuardianFullName(AdditionalInfoData.guardian_full_name || "");
      setContactNumber(AdditionalInfoData.guardian_contact_number || "");
      setGuardianRelationship(AdditionalInfoData.guardian_relationship || "");
      setCustodyStatus(AdditionalInfoData.custody_status || "");
      setLegalCustodianFullName(AdditionalInfoData.legal_custodian_full_name || "");
      setCustodianRelationship(AdditionalInfoData.custodian_relationship || "");
      setCustodyOrderOnFile(AdditionalInfoData.custody_order_on_file == 1 || AdditionalInfoData.custody_order_on_file === true);
      const parsedDate = dayjs(AdditionalInfoData.custody_effective_date);
      setCustodyEffectiveDate(
        AdditionalInfoData.custody_effective_date && parsedDate.isValid()
          ? parsedDate
          : null
      );
      setCustodyNotes(AdditionalInfoData.custody_notes || "");
      setEmploymentStatus(AdditionalInfoData.employment_status || "");
      setEmployerName(AdditionalInfoData.employer_name || "");
      setOccupation1(AdditionalInfoData.employment_occupation || "");
      setHousingStatus(AdditionalInfoData.housing_status || "");
      setLivingArrangement(AdditionalInfoData.living_arrangement || "");
      setHouseholdSize(AdditionalInfoData.household_size || "");
      setOccupation2(AdditionalInfoData.social_occupation || "");
      setSmokingStatus(AdditionalInfoData.smoking_status || "");
      setVeteranStatus(AdditionalInfoData.veteran_status || "");
      setDisabilityStatus(AdditionalInfoData.disability_status || "");
      setClientNotes(AdditionalInfoData.client_notes || "");
    }
  }, [AdditionalInfoData]);

  const handleSave = () => {
    const payload = {
      school_name: schoolName,
      grade: grade,
      student_status: studentStatus,
      guardian_full_name: guardianFullName,
      guardian_contact_number: contactNumber,
      guardian_relationship: guardianRelationship,
      custody_status: custodyStatus,
      legal_custodian_full_name: legalCustodianFullName,
      custodian_relationship: custodianRelationship,
      custody_order_on_file: custodyOrderOnFile ? 1 : 0,
      custody_effective_date: custodyEffectiveDate ? custodyEffectiveDate.format("YYYY-MM-DD") : null,
      custody_notes: custodyNotes,
      employment_status: employmentStatus,
      employer_name: employerName,
      employment_occupation: occupation1,
      housing_status: housingStatus,
      living_arrangement: livingArrangement,
      household_size: householdSize,
      social_occupation: occupation2,
      smoking_status: smokingStatus,
      veteran_status: veteranStatus,
      disability_status: disabilityStatus,
      client_notes: clientNotes,
    };
    dispatch(UpdateAdditionalInfo(payload));
  };

  return (
    <Div width="100%" background="#FFFFFF" padding="24px 40px">
      {/* School Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        School Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">School Name</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={schoolName}
            onChange={(e) => setSchoolName(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Grade</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={grade}
            onChange={(e) => setGrade(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Student Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Student Status"
            value={studentStatus || undefined}
            onChange={setStudentStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Full-time Student">Full-time Student</Option>
            <Option value="Part-time Student">Part-time Student</Option>
            <Option value="Home schooled">Home schooled</Option>
            <Option value="Graduated">Graduated</Option>
            <Option value="Not Applicable">Not Applicable</Option>
          </Select>
        </FormGroup>
      </Display>
      <Hrline ml="-40px" mt="0px" mb="20px" />

      {/* Guardian Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Guardian Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Guardian Full Name</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={guardianFullName}
            onChange={(e) => setGuardianFullName(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Contact Number</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={contactNumber}
            onChange={(e) => setContactNumber(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Relationship</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Relationship"
            value={guardianRelationship || undefined}
            onChange={setGuardianRelationship}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Mother">Mother</Option>
            <Option value="Father">Father</Option>
            <Option value="Grandparent">Grandparent</Option>
            <Option value="Foster Parent">Foster Parent</Option>
            <Option value="Legal Guardian">Legal Guardian</Option>
            <Option value="Sibling">Sibling</Option>
            <Option value="Other Relative">Other Relative</Option>
            <Option value="Other">Other</Option>
          </Select>
        </FormGroup>
      </Display>
      <Hrline ml="-40px" mt="0px" mb="20px" />

      {/* Custody Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Custody Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Custody Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Custody Status"
            value={custodyStatus || undefined}
            onChange={setCustodyStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Sole Custody">Sole Custody</Option>
            <Option value="Joint Custody">Joint Custody</Option>
            <Option value="Foster Care">Foster Care</Option>
            <Option value="Court Appointed Guardian">Court Appointed Guardian</Option>
            <Option value="State Custody">State Custody</Option>
            <Option value="No Custody Restrictions">No Custody Restrictions</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Legal Custodian Full Name</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={legalCustodianFullName}
            onChange={(e) => setLegalCustodianFullName(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Custodian Relationship</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Relationship"
            value={custodianRelationship || undefined}
            onChange={setCustodianRelationship}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Mother">Mother</Option>
            <Option value="Father">Father</Option>
            <Option value="Legal Guardian">Legal Guardian</Option>
            <Option value="Foster Parent">Foster Parent</Option>
            <Option value="Grandparent">Grandparent</Option>
            <Option value="Agency">Agency</Option>
            <Option value="Other">Other</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Custody Order on File</FormLabel>
          <div style={{ justifySelf: "flex-start" }}>
            <Switch
              checked={custodyOrderOnFile}
              onChange={setCustodyOrderOnFile}
            />
          </div>
        </FormGroup>
      </Display>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Custody Effective Date</FormLabel>
          <DatePicker
            style={{ width: 220, height: 32 }}
            onChange={setCustodyEffectiveDate}
            value={custodyEffectiveDate}
            format="MM-DD-YYYY"
          />
        </FormGroup>
        <FormGroup display="grid" style={{ flexGrow: 1 }}>
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Custody Notes</FormLabel>
          <Inputbox
            type="text"
            width="90%"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={custodyNotes}
            onChange={(e) => setCustodyNotes(e.target.value)}
          />
        </FormGroup>
      </Display>
      <Hrline ml="-40px" mt="0px" mb="20px" />

      {/* Employment Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Employment Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Employment Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Status"
            value={employmentStatus || undefined}
            onChange={setEmploymentStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Full time Employed">Full time Employed</Option>
            <Option value="Part time Employed">Part time Employed</Option>
            <Option value="Self Employed">Self Employed</Option>
            <Option value="Contract, per diem">Contract, per diem</Option>
            <Option value="Full time Student">Full time Student</Option>
            <Option value="Part time Student">Part time Student</Option>
            <Option value="On Active Military duty">On Active Military duty</Option>
            <Option value="Retired">Retired</Option>
            <Option value="Leave of Absence">Leave of Absence</Option>
            <Option value="Temporarily Unemployed">Temporarily Unemployed</Option>
            <Option value="Unemployed">Unemployed</Option>
            <Option value="Something Else">Something Else</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Employer Name</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={employerName}
            onChange={(e) => setEmployerName(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Occupation</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={occupation1}
            onChange={(e) => setOccupation1(e.target.value)}
          />
        </FormGroup>
      </Display>
      <Hrline ml="-40px" mt="0px" mb="20px" />

      {/* Housing Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Housing Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Housing Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Status"
            value={housingStatus || undefined}
            onChange={setHousingStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Stable Housing">Stable Housing</Option>
            <Option value="Temporary Housing">Temporary Housing</Option>
            <Option value="Homeless">Homeless</Option>
            <Option value="Shelter">Shelter</Option>
            <Option value="Transitional Housing">Transitional Housing</Option>
            <Option value="Assisted Living">Assisted Living</Option>
            <Option value="Nursing Facility">Nursing Facility</Option>
            <Option value="Unknown">Unknown</Option>
            <Option value="Prefer Not to Disclose">Prefer Not to Disclose</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Living Arrangement</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Living Arrangement"
            value={livingArrangement || undefined}
            onChange={setLivingArrangement}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Lives Alone">Lives Alone</Option>
            <Option value="Lives with Family">Lives with Family</Option>
            <Option value="Lives with Spouse">Lives with Spouse</Option>
            <Option value="Lives with Friends">Lives with Friends</Option>
            <Option value="Group Home">Group Home</Option>
            <Option value="Residential Facility">Residential Facility</Option>
            <Option value="Foster Home">Foster Home</Option>
            <Option value="Other">Other</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Household Size</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={householdSize}
            onChange={(e) => {
              const val = e.target.value;
              if (val === "" || (/^[0-9\b]+$/.test(val) && val.length <= 2)) {
                setHouseholdSize(val);
              }
            }}
          />
        </FormGroup>
      </Display>
      <Hrline ml="-40px" mt="0px" mb="20px" />

      {/* Social Information */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Social Information
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Occupation</FormLabel>
          <Inputbox
            type="text"
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            paddingRight="12px"
            value={occupation2}
            onChange={(e) => setOccupation2(e.target.value)}
          />
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Smoking Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Status"
            value={smokingStatus || undefined}
            onChange={setSmokingStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Current Smoker">Current Smoker</Option>
            <Option value="Former Smoker">Former Smoker</Option>
            <Option value="Never Smoked">Never Smoked</Option>
            <Option value="Unknown">Unknown</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid" marginRight="24px">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Veteran Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Status"
            value={veteranStatus || undefined}
            onChange={setVeteranStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="Yes">Yes</Option>
            <Option value="No">No</Option>
            <Option value="Unknown">Unknown</Option>
            <Option value="Prefer not to Answer">Prefer not to Answer</Option>
          </Select>
        </FormGroup>
        <FormGroup display="grid">
          <FormLabel fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left">Disability Status</FormLabel>
          <Select
            popupClassName="custom-blue-select"
            placeholder="Select Status"
            value={disabilityStatus || undefined}
            onChange={setDisabilityStatus}
            style={{ width: 200, height: 32 }}
          >
            <Option value="No Disability">No Disability</Option>
            <Option value="Physical Disability">Physical Disability</Option>
            <Option value="Visual Impairment">Visual Impairment</Option>
            <Option value="Hearing Impairment">Hearing Impairment</Option>
            <Option value="Intellectual / Developmental Disability">Intellectual / Developmental Disability</Option>
            <Option value="Cognitive Disability">Cognitive Disability</Option>
            <Option value="Speech Disability">Speech Disability</Option>
            <Option value="Multiple Disabilities">Multiple Disabilities</Option>
            <Option value="Other">Other</Option>
            <Option value="Prefer Not to Answer">Prefer Not to Answer</Option>
            <Option value="Unknown">Unknown</Option>
          </Select>
        </FormGroup>
      </Display>

      {/* Client Notes */}
      <Text
        fontFamily="Inter"
        fontWeight="500"
        fontSize="14px"
        lineHeight="17px"
        color="#334257"
        marginBottom="16px"
        textAlign="left"
      >
        Client Notes
      </Text>
      <Display display="flex" mb="20px">
        <FormGroup display="grid" style={{ width: "100%" }}>
          <textarea
            style={{
              width: "100%",
              height: "100px",
              background: "#ffffff",
              border: "1px solid #cbd5e0",
              borderRadius: "4px",
              padding: "12px",
              resize: "vertical"
            }}
            value={clientNotes}
            onChange={(e) => setClientNotes(e.target.value)}
          />
        </FormGroup>
      </Display>

      <Hrline ml="-40px" mt="0px" mb="20px" />
      <Display display="flex" pb="20px">
        <Button
          padding="8px 16px"
          height="32px"
          border=" 1px solid #2C7BE5"
          background=" #FFF"
          hoverBackColor="rgba(244, 246, 249, 0.75)"
          borderRadius="4px"
          fontFamily="'Inter',san-serif"
          fontWeight="500"
          lineHeight="17px"
          color="#2C7BE5"
          marginRight="20px"
          className="close_active"
        >
          Cancel
        </Button>
        <Button
          padding="8px 24px"
          height="32px"
          border=" 1px solid #2C7BE5"
          background=" #2C7BE5"
          hoverBackColor="#1a60c2"
          borderRadius="4px"
          fontFamily="'Inter',san-serif"
          fontWeight="500"
          lineHeight="17px"
          color="#FFF"
          onClick={handleSave}
        >
          Save
        </Button>
      </Display>
    </Div>
  );
};

export default AdditionalInfo;
